import { RegulatorySearchFilterType } from "@/components/business/RegulatoryContainer/regulatoryList.types";

export const REGULATORY_LIST_EDITOR_INFO_FILTER: RegulatorySearchFilterType[] =
  [
    {
      key: "allEditorInfo",
      name: "All Editor",
      isAllInfo: true,
    },
    {
      key: "mcEditorInfo",
      name: "MC Editor",
      code: "S112",
      isAllInfo: false,
    },
    {
      key: "ftEditorInfo",
      name: "FT Editor",
      code: "S911",
      isAllInfo: false,
    },
  ];

export const REGULATORY_LIST_EDITOR_INFO_FILTER_KEY = [
  "allEditorInfo",
  "mcEditorInfo",
  "ftEditorInfo",
] as const;
